import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface SubFolderDialogResult {
  name: string;
  color: string;
}

@Component({
  standalone: false,
  selector: 'wr-sub-folder-dialog',
  templateUrl: './sub-folder-dialog.component.html',
  styleUrls: ['./sub-folder-dialog.component.scss'],
})
export class SubFolderDialogComponent implements OnInit {

  @Input()
  header = 'Unterordner anlegen';

  @Input()
  name = '';

  @Input()
  color = '';

  form!: FormGroup;

  onSubmit = (): SubFolderDialogResult => this.form.value;

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl(this.name, [Validators.required]),
      color: new FormControl(this.color, [Validators.required]),
    });
  }
}
